(function () {
  const SELECTOR = '[data-gift-wrap]';
  let variantCache = {}; // handle -> variantId

  async function getVariantIdByHandle(handle) {
    if (variantCache[handle]) return variantCache[handle];
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Gift wrap: product handle not found: ${handle}`);
    const data = await res.json();
    const variant = data.variants.find(v => v.available) || data.variants[0];
    if (!variant) throw new Error('Gift wrap: no variants available.');
    variantCache[handle] = variant.id;
    return variant.id;
  }

  async function getCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }

  function findGiftWrapLine(cart, variantId) {
    return cart.items.find(i => i.id === variantId);
  }

  function setLoading(el, isLoading) {
    const spinner = el.querySelector('.gift-wrap-toggle__spinner');
    const cb = el.querySelector('[data-gw-checkbox]');
    if (spinner) spinner.hidden = !isLoading;
    if (cb) cb.disabled = isLoading;
  }

  async function syncUI(el) {
    const handle = el.dataset.gwHandle;
    try {
      const [variantId, cart] = await Promise.all([getVariantIdByHandle(handle), getCart()]);
      const line = findGiftWrapLine(cart, variantId);
      el.querySelector('[data-gw-checkbox]').checked = !!line;
    } catch (e) {
      console.warn(e);
    }
  }

  async function addGiftWrap(el) {
    const handle = el.dataset.gwHandle;
    setLoading(el, true);
    try {
      const variantId = await getVariantIdByHandle(handle);
      // Ensure only one gift wrap item is present
      const cart = await getCart();
      const existing = findGiftWrapLine(cart, variantId);
      if (existing) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: existing.key, quantity: 1 })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      }
      await refreshSections();
    } catch (e) {
      console.error(e);
      // rollback checkbox
      el.querySelector('[data-gw-checkbox]').checked = false;
    } finally {
      setLoading(el, false);
    }
  }

  async function removeGiftWrap(el) {
    const handle = el.dataset.gwHandle;
    setLoading(el, true);
    try {
      const variantId = await getVariantIdByHandle(handle);
      const cart = await getCart();
      const line = findGiftWrapLine(cart, variantId);
      if (line) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      }
      await refreshSections();
    } catch (e) {
      console.error(e);
      // rollback checkbox
      el.querySelector('[data-gw-checkbox]').checked = true;
    } finally {
      setLoading(el, false);
    }
  }

  // Dawn section refresh (cart drawer + cart page totals)
  async function refreshSections() {
    try {
      const sectionsToRender = [
        'cart-drawer',           // drawer
        'main-cart-items',       // cart page line items
        'main-cart-footer'       // cart page totals/upsells
      ];
      const res = await fetch(`${window.location.pathname}?sections=${sectionsToRender.join(',')}`);
      const json = await res.json();

      // Update drawer if present
      const drawer = document.querySelector('cart-drawer');
      if (drawer && json['cart-drawer']) {
        drawer.outerHTML = json['cart-drawer'];
      }
      // Update cart page sections if present
      const items = document.getElementById('main-cart-items');
      if (items && json['main-cart-items']) {
        items.outerHTML = json['main-cart-items'];
      }
      const footer = document.getElementById('main-cart-footer');
      if (footer && json['main-cart-footer']) {
        footer.outerHTML = json['main-cart-footer'];
      }
    } catch (e) {
      console.warn('Section refresh failed (non-blocking).', e);
      // Fallback: reload page if needed
      // location.reload();
    } finally {
      // Re-sync all toggles after DOM changes
      document.querySelectorAll(SELECTOR).forEach(syncUI);
    }
  }

  function bind(el) {
    const checkbox = el.querySelector('[data-gw-checkbox]');
    if (!checkbox) return;

    checkbox.addEventListener('change', (ev) => {
      if (ev.target.checked) addGiftWrap(el);
      else removeGiftWrap(el);
    });

    // Initial state
    syncUI(el);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(bind);

    // Re-bind when Dawn re-renders the cart drawer
    document.addEventListener('cart:updated', () => {
      document.querySelectorAll(SELECTOR).forEach(bind);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
